import { z } from "zod";
export const bulkJobPriceStatsSchema = z.object({
    jobIds: z.array(z.string().uuid()).min(1),
});
//# sourceMappingURL=priceStats.schema.js.map